import React from "react";

const SimpleModal = ({
  isOpen,
  onClose,
  children,
  currentStep,
  checkStep = 2,
}) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[50000000]">
      <div
        className={`relative w-full ${
          currentStep && currentStep === checkStep
            ? "max-w-[1000px]"
            : "max-w-[700px]"
        }  p-6 mx-2 bg-white rounded-lg shadow-lg animate-fadeIn`}
      >
        <button
          className="absolute text-2xl font-bold text-gray-400 top-4 right-4 hover:text-gray-700 focus:outline-none"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>
        {children}
      </div>
    </div>
  );
};

export default SimpleModal;
